// import { Uint256 } from "web3";
import { getConnectionPool } from "../../core/connectionPool";
import { checkMigrate } from "../../init/sdkInit";
import { request, response } from "../../proto/bundle";
// import { stat } from "fs";
import Long from "long";
// import { C } from "vitest/dist/chunks/environment.d.cL3nLXbE";
export class Reply{
    id:number | null = null;
   email:string | null;
   content:string | null;
   createdTime:  Long | number ;
   modifiedTime:  Long | number ;

   constructor(email:string | null,content:string | null,createdTime:Long | number ,modifiedTime:Long | number ){
        this.email=email;
        this.content=content;
        this.createdTime=createdTime;
        this.modifiedTime=modifiedTime;
    }
    setContent(content:string){
        this.content=content;
    }
    setModifiedTime(time: Long | number){
        this.modifiedTime=time;
    }
    setCreatedTime(time: Long | number){
        this.createdTime=time;
    }
    getEmail():string | null{
        return this.email;
    }
    getContent():string | null{
        return this.content;
    }
    getCreatedTime():Long | number{
        return this.createdTime;
    }
    getModifiedTime():Long  | number {
        return this.modifiedTime;
    }
}

export class CommentStat{
    email:string;
    content:string;
    createTime: Long | number ;
    modifiedTime:Long | number ;
    mentionedEmails:string[];
    replies:Reply[];

    constructor(email?:string,content?:string,createTime?: number | Long,modifiedTime?:  number | Long,mentionedEmails?:string[],replies?:Reply[]){
        this.email=email || "";
        this.content=content || "";
        this.createTime=createTime || Long.UZERO;
        this.modifiedTime=modifiedTime || Long.UZERO;
        this.mentionedEmails=mentionedEmails || [];
        this.replies=replies || [];
    }

    setEmail(email:string){
        this.email=email;
    }
    setContent(content:string){
        this.content=content;
    }
    setCreateTime(time: number | Long){
        this.createTime=time;
    }
    setModifiedTime(time: number | Long){
        this.modifiedTime=time;
    }
    setMentionedEmails(emails:string[]){
        this.mentionedEmails=emails;
    }
    setReplies(replies:Reply[]){
        this.replies=replies;
    }
    getEmail():string{
        return this.email;
    }
    getContent():string{
        return this.content;
    }
    getCreateTime(): number | Long {
        return this.createTime;
    }
    getModifiedTime(): number | Long {
        return this.modifiedTime;
    }
    getMentionedEmails():string[]{
        return this.mentionedEmails;
    }
    getReplies():Reply[]{
        return this.replies;
    }
}

export class Comment{
    private parentPath:string;
    private fileName:string;
    private location:string;
    private comment:CommentStat;
    private state:string;
    private commentId:Uint8Array;
    constructor(){
        this.parentPath="";
        this.fileName="";
        this.location="";
        this.comment=new CommentStat();
        this.state="";
        this.commentId=new Uint8Array();
    }
    setParentPath(path:string){
        this.parentPath=path;
    }
    setFileName(name:string){
        this.fileName=name;
    }

    setCommentId(id:Uint8Array){
        this.commentId=id;
    }
    setLocation(location:string){
        this.location=location;
    }
    setComment(comment:CommentStat){
        this.comment=comment;
    }
    setState(state:string){
        this.state=state;
    }
    setReplies(replies:Reply[]){
        this.comment.replies=replies;
    }

    getReplies():Reply[]{
        return this.comment.replies;
    }
    getState():string{
        return this.state;
    }

    getLocation():string{
        return this.location;
    }

    getCommentInfo():CommentStat{
        return this.comment;
    }

    getParentPath():string{
        return this.parentPath;
    }

    getFileName():string{
        return this.fileName;
    }

    getCommentId():Uint8Array{
        return this.commentId;
    }
    async addReply(reply:Reply):Promise<void>{
        this.comment.replies.push(reply);
        // console.log("Added reply:",reply);
    }

    async removeComment():Promise<void>{
        const pool = await getConnectionPool();
        let req=request.Request.create({
            id:null,
            reqCreateTime:Date.now(),
            removeComment:request.RemoveComment.create({
                parentPath:this.parentPath,
                fileName:this.fileName,
                commentId:this.commentId
            })
        });
        const resp=await pool.sendAndWait(req);
        checkMigrate(resp.removeComment.status)

        if (!resp.removeComment || resp.removeComment.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to remove comment(${resp.removeComment?.status})`);
        }
    }

    async addComment():Promise<void>{
        // console.log("🚀 Adding comment:",this.comment);
        // console.log("🚀 At location:",this.location);
        // console.log("🚀 In file:",this.fileName);
        // console.log("🚀 Under parent path:",this.parentPath);
        // console.log("🚀 With mentioned emails:",this.comment.mentionedEmails);
        // console.log("🚀 state:",this.state);

        this.comment.mentionedEmails=(new Set(this.comment.mentionedEmails)).size === 1 && this.comment.mentionedEmails[0] === "" ? [] : this.comment.mentionedEmails;
        // console.log("🚀 With mentioned emails:",this.comment.mentionedEmails);
        let replies:request.IReply[]=[];
        for(let r of this.comment.replies){
            replies.push({
                email:r.email || "",
                content:r.content || "",
                createdTime:typeof r.createdTime === "number" ? Long.fromNumber(r.createdTime) : r.createdTime,
                modifiedTime:typeof r.modifiedTime === "number" ? Long.fromNumber(r.modifiedTime) : r.modifiedTime,
            });
        }

        let req_comment=request.Comment.create({
            email:this.comment.email,
            content:this.comment.content,
            createdTime:typeof this.comment.createTime === "number" ? Long.fromNumber(this.comment.createTime) : this.comment.createTime,
            modifiedTime:typeof this.comment.modifiedTime === "number" ? Long.fromNumber(this.comment.modifiedTime) : this.comment.modifiedTime,
            mentionedEmails:this.comment.mentionedEmails,
            replies:replies
        });
        // console.log("🚀 Request comment protobuf:",req_comment);
        const pool = await getConnectionPool();
        let req=request.Request.create({
            id:null,
            reqCreateTime:Date.now(),
            addComment:request.AddComment.create({
                parentPath:this.parentPath,
                fileName:this.fileName,
                location:this.location,
                comment:req_comment
            })
        });

        const resp=await pool.sendAndWait(req);
        checkMigrate(resp.addComment.status)
        let commentId=resp.addComment.commentId;
        // console.log("🚀 Received comment ID:",commentId);
        this.commentId=commentId || new Uint8Array();
        if (!resp.addComment || resp.addComment.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to add comment(${resp.addComment?.status})`);
        }
    }

    async updateComment(updateType:string,replyIndex?:number,isResolved?:boolean,reOpen?:boolean):Promise<void>{
        // console.log("is resolved ",isResolved,reOpen);
        let replies:request.IReply[]=[];
        for(let r of this.comment.replies){
            replies.push({
                email:r.email || "",
                content:r.content || "",
                createdTime:typeof r.createdTime === "number" ? Long.fromNumber(r.createdTime) : r.createdTime,
                modifiedTime:typeof r.modifiedTime === "number" ? Long.fromNumber(r.modifiedTime) : r.modifiedTime,
            });
        }
        let req_comment=request.Comment.create({
            email:this.comment.email,
            content:this.comment.content,
            createdTime:typeof this.comment.createTime === "number" ? Long.fromNumber(this.comment.createTime) : this.comment.createTime,
            modifiedTime:typeof this.comment.modifiedTime === "number" ? Long.fromNumber(this.comment.modifiedTime) : this.comment.modifiedTime,
            mentionedEmails:this.comment.mentionedEmails,
            replies:replies
        });
        let update=request.UpdateType.UpdateReplyText
        if(updateType==="ADD_REPLY"){
            replyIndex=this.comment.replies.length - 1;
            update=request.UpdateType.AddReply;
        }else if(updateType==="REMOVE_REPLY"){
            update=request.UpdateType.DeleteReply;
        }else if (updateType==="UPDATE_REPLY_TEXT"){
            update=request.UpdateType.UpdateReplyText;
        }else if(updateType==="UPDATE_COMMENT_TEXT"){
            update=request.UpdateType.UpdateText
        }else if(updateType==="UPDATE_STATUS"){
            update=request.UpdateType.UpdateStatus;
        }else if(updateType==="UPDATE_LOCATION"){
            update=request.UpdateType.UpdateLocation;
        }
        else{
            throw new Error(`Invalid update type: ${updateType}`);
        }
        // console.log("🚀 Updating comment with type:",updateType);
        // console.log("🚀 Updated comment:",req_comment);
        const pool = await getConnectionPool();
        let req=request.Request.create({
            id:null,
            reqCreateTime:Date.now(),
            updateComment:request.UpdateComment.create({
                parentPath:this.parentPath,
                updateType:update,
                replyIndex:replyIndex,
                fileName:this.fileName,
                commentId:this.commentId,
                comment:req_comment,
                location:this.location,
                state:this.state,
                isResolved:isResolved,
                reOpen:reOpen
            })
        });
        const resp=await pool.sendAndWait(req);
        checkMigrate(resp.updateComment.status)

        if (!resp.updateComment || resp.updateComment.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to update comment(${resp.updateComment?.status})`);
        }
    }

    async getComment():Promise<Comment>{
        const pool = await getConnectionPool();
        let req=request.Request.create({
            id:null,
            reqCreateTime:Date.now(),
            getComment:request.GetComment.create({
                parentPath:this.parentPath,
                fileName:this.fileName,
                commentId:this.commentId
            })
        });
        const resp=await pool.sendAndWait(req);
        checkMigrate(resp.getComment.status)

        if (!resp.getComment || resp.getComment.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to get comment(${resp.getComment?.status})`);
        }
        let resp_comment=resp.getComment.comment;
        if(!(resp_comment instanceof Uint8Array)){
            console.warn("Response comment is not valid");
            return new Comment();
        }

        let decodedComment:any;
        try{
            decodedComment=response.Comment.decode(resp_comment);
        }catch (e){
            console.warn("Failed to decode comment from response");
            return new Comment();
        }
        let comment_replies=decodedComment?.replies || [];
        let replies:Reply[]=[];
        let i=0;
        for(let r of comment_replies){
            const reply=new Reply(
                r.email || "",
                r.content || "",
                r.createdTime || Long.UZERO,
                r.modifiedTime || Long.UZERO
            );
            reply.id=i;
            replies.push(reply);
            i++;
        }
        let comment= new Comment();
        comment.setParentPath(this.parentPath);
        comment.setFileName(this.fileName);
        comment.setCommentId(decodedComment.commentId);
        comment.setLocation(resp.getComment.location || "");
        comment.setState(resp.getComment.commentStatus || "");
        comment.setComment(new CommentStat(
            decodedComment.email || "",
            decodedComment.content || "",
            decodedComment.createdTime || Long.UZERO,
            decodedComment.modifiedTime || Long.UZERO,
            decodedComment.mentionedEmails || [],
            replies,
        ));
        let location=resp.getComment.location || "";
        // console.log("🚀 Got comment:",comment);
        // console.log("🚀 Got location:",location);

        return comment;
    }


    async listComments(timestamp:Long,numberOfComments:Long): Promise<[Comment[],String]>{
        const pool = await getConnectionPool();
        let req = request.Request.create({
            id: null,
            reqCreateTime: Date.now(),
            listComments: request.ListComments.create({
                parentPath: this.parentPath,
                fileName: this.fileName,
                currentItems: numberOfComments,
                currentTime:timestamp
            })
        });
        const resp = await pool.sendAndWait(req);
        checkMigrate(resp.listComments.status)

        if (!resp.listComments || resp.listComments.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to list comments(${resp.listComments?.status})`);
        }

        const serverComments = resp.listComments.comments || [];
        const serverLocations = resp.listComments.locations || [];
        const states = resp.listComments.commentStatus || [];
        const comments: Comment[] = [];
        const commentIds=resp.listComments.commentIds || [];
        for (let i = 0; i < serverComments.length; i++) {
            let comment=serverComments[i];
            let loc=serverLocations[i] || "";
            const state=states[i] || "";
            if(!(comment instanceof Uint8Array)){
                console.warn("Response comment is not valid");
                return [[],""];
            }

            let decodedComment:any;
            try{
                decodedComment=response.Comment.decode(comment);
            }catch (e){
                console.warn("Failed to decode comment from response");
                return [[],""];
            }
            let replies: Reply[] = [];
            const serverReplies = decodedComment.replies || [];
            let j=0;
            for (let r of serverReplies) {
                const reply=new Reply(
                    r.email || "",
                    r.content || "",
                    r.createdTime || Long.UZERO,
                    r.modifiedTime || Long.UZERO
                );
                reply.id=j;
                replies.push(reply);
                j++;
            }
            let commentObject= new Comment();
            commentObject.setParentPath(this.parentPath);
            commentObject.setFileName(this.fileName);
            commentObject.setCommentId(commentIds[i] || new Uint8Array());
            commentObject.setLocation(loc);
            commentObject.setState(state);
            commentObject.setComment(new CommentStat(
                decodedComment.email || "",
                decodedComment.content || "",
                decodedComment.createdTime || Long.UZERO,
                decodedComment.modifiedTime || Long.UZERO,
                decodedComment.mentionedEmails || [],
                replies,
            ));
            comments.push(commentObject);
        }
        return [comments,resp.listComments.listStatus];
    }
}
